// The cart's phone breakpoint, the app-wide phone boundary (`PHONE_MEDIA_QUERY`, below
// 768px): /cart switches to the stacked row (4379:12439) and the Order footer stacks.
// Guarded for environments without matchMedia (tests, SSR), where it reports the desktop
// layout.
import { useEffect, useState } from 'react';
import { PHONE_MEDIA_QUERY } from '../design-system/breakpoints';

export const CART_NARROW_MEDIA_QUERY = PHONE_MEDIA_QUERY;

function matchesNow(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(CART_NARROW_MEDIA_QUERY).matches
    : false;
}

export function useIsNarrowViewport(): boolean {
  const [narrow, setNarrow] = useState(matchesNow);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(CART_NARROW_MEDIA_QUERY);
    const onChange = () => setNarrow(query.matches);
    onChange();
    // Safari before 14 ships a MediaQueryList without addEventListener; fall back
    // to its addListener/removeListener pair so the layout still follows a later
    // viewport or orientation change there.
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', onChange);
      return () => query.removeEventListener('change', onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return narrow;
}
